import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wind } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Settings: which supporters SOS Calm can message
export const SosSettingsCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/sos/settings").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const toggle = async (id) => {
    const ids = d.supporters.filter((s) => s.available && (s.id === id ? !s.selected : s.selected)).map((s) => s.id);
    const prev = d;
    setD({ ...d, supporters: d.supporters.map((s) => (s.id === id ? { ...s, selected: !s.selected } : s)) });
    try { await api.put("/sos/settings", { supporter_ids: ids }); toast.success("SOS supporters saved"); }
    catch (e) { setD(prev); toast.error(errMsg(e)); }
  };
  return (
    <div className="mm-card p-5" data-testid="sos-settings">
      <h3 className="font-semibold flex items-center gap-2"><Wind size={18} className="text-mm-primary" />SOS Calm supporters</h3>
      <p className="text-sm text-mm-muted mt-1">Who gets "is having a hard moment and would appreciate a check-in" when you tap Message my supporters. No other details are shared, and each person gets at most one every 6 hours.</p>
      {d.supporters.length ? (
        <div className="mt-3 space-y-2">
          {d.supporters.map((s) => (
            <label key={s.id} className={`flex items-center gap-3 text-sm ${s.available ? "cursor-pointer" : "opacity-50"}`}>
              <input type="checkbox" className="w-4 h-4" disabled={!s.available} checked={s.selected} onChange={() => toggle(s.id)} data-testid={`sos-settings-${s.id}`} />
              {s.name}{!s.available && " (no email or link expired)"}
            </label>
          ))}
        </div>
      ) : <p className="text-sm mt-3">You haven't added any trusted supporters yet.</p>}
      {d.custom && <button className="text-sm text-mm-primary font-medium mt-3" data-testid="sos-settings-reset" onClick={async () => {
        try { await api.put("/sos/settings", { supporter_ids: null }); const r = await api.get("/sos/settings"); setD(r.data); toast.success("All supporters will be messaged, including new ones"); }
        catch (e) { toast.error(errMsg(e)); }
      }}>Use all my supporters (including new ones)</button>}
      <p className="text-xs text-mm-muted mt-3" data-testid="sos-settings-uses">You've used SOS Calm {d.uses} time{d.uses === 1 ? "" : "s"}. Only you can see this.</p>
    </div>
  );
};
